module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Box#2-a8d4f74900203e79b79420e2e15513c9.svg";